module.exports = __webpack_public_path__ + "img/back_width.57fc1b6a.png";